import React, { useEffect, useState } from 'react';
import 'primeicons/primeicons.css';
import 'primereact/resources/themes/lara-light-indigo/theme.css';
import 'primereact/resources/primereact.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import "react-datepicker/dist/react-datepicker.css";
import { Routes, Route } from 'react-router-dom';

import './App.scss';

import LoginForm from './components/login/LoginForm';
import Layout from './components/layout/Layout.js';
import ChartOfAccount from './components/Accountant/ChartOfAccount.js';
import OrganizationProfile from './components/settings/OrganizationProfile';
// import Customers from './components/Sales/Customers';
import Customers from './components/Sales/Customers.js';
import ListofItems from './components/Items/ListofItems';
import COATable from './components/Accountant/COATable';
import Vendor from './components/Purchases/Vendor';
import Ledger from './components/reports/Ledger';
// import NewJournal from './components/Accountant/NewJournal';
import NewJournal from './components/journal/NewJournal';
import JournalList from './components/journal/JournalList';
// import TestJournal from './components/Accountant/TestJournal';
import LedgerList from './components/reports/LedgerList';
import GeneralLedger from './components/reports/GeneralLedger';
import UpdateJournal from './components/journal/UpdateJournal';
import LocalStorageService from './services/localstorage';
import GV from './services/globalVar'
import LoginService from './services/login';
import { useNavigate } from "react-router-dom";
import { Suspense} from 'react';
import { ImSpinner10 } from 'react-icons/im';
// import { ProgressSpinner } from 'primereact/progressspinner';

import Dashboard from './components/Dashboard/Dashboard';
import { BlockUI } from 'primereact/blockui';
import LedgerSearch from './components/reports/LedgerSearch';
// import ProfitLoss from './components/reports/ProfitLoss/ProfitLoss.js';
import UserAccountManagement from './components/Administration/Security/UserAccountManagement';
import PettyCash from './components/PettyCash/PettyCash';
import PettyCashMonth from './components/PettyCash/PettyCashMonth';
import BudgetForecasting from './components/Budget/BudgetForecasting';
import Expenses from './components/Budget/Expenses';
import FundRequest from './components/Budget/FundRequest';
import FundApproval from './components/Budget/FundApproval';
import ExpenseAnalysis from './components/Budget/ExpenseAnalysis';
import ExpenseSummary from './components/Budget/ExpenseSummary';
import ExpenseSummaryView from './components/Budget/ExpenseSummaryView';
import Layouttwo from './components/layout/Layouttwo';
import PettyCashReport from './components/PettyCash/PettyCashReport';
import PettyCashWeek from './components/PettyCash/PettyCashWeek';
// import PurchaseExpense from './components/Budget/PurchaseExpense.js';
// import NewExpense from './components/Budget/NewPurchase.js';
import NewPurchase from './components/Purchases/NewPurchase.js';
// import NewPurchase from './components/Budget/NewPurchase.js';
import PurchaseExpense from './components/Purchases/PurchaseExpense.js';
import ExpenseTracking from './components/Budget/ExpenseTracking.js';
// import PurchaseList from './components/Budget/PurchaseList.js';
import PurchaseList from './components/Purchases/PurchaseList.js';
import NewDashboard from './components/Dashboard/NewDashboard.js';
// import Invoice from './components/Sales/Invoice.js';
// import Invoice from './components/Sales/Invoice.js';
// import Incoice from './components/Sales/Invoice.js'
// import PrivateRouter from './components/PrivateRouter';
import 'antd/dist/reset.css';
// import { Estimate } from './components/sales/Estimate.js';
// import EstimateGrid  from './components/Sales/EstimateGrid.js';
import CreditNoteGrid from './components/Sales/CreditNoteGrid.js';
import Invoice from './components/Sales/Invoice.js';
import { EstimateGrid } from './components/Sales/EstimateGrid.js';
import NewPurchaseOrderForm from './components/Purchases/NewPurchaseOrderForm.js';
import NewPurchaseOrderGrid from './components/Purchases/NewPurchaseOrderGrid.js';
import DebitNoteGrid from './components/Purchases/DebitNoteGrid.js';
import EmployeeLoanGrid from './components/Loan/EmployeeLoanGrid.js'
import Overalldashboard from './components/Dashboard/Overalldashboard.js';
import ReportsCenter from './components/reports/ReportCenter/ReportsCenter.js';
import DynamicForm from './components/TemplateManager.js/DynamicForm.js';
import Tds from './components/Tds/Tds.js';
import BankTransaction from './components/Banking/BankTransaction.js';
import AccessDenied from './components/layout/AccessDenied.js';
import PrivateRouter from './components/layout/PrivateRouter.js';
import { PermissionProvider } from './components/layout/CheckAccess.js';
import Ticket from './components/layout/Ticket.js';
import PaymentVoucher from './components/Sales/PaymentVoucher.js';
import ReceiptVoucher from './components/Purchases/ReceiptVoucher.js';
import Banking from './components/Banking/Banking.js';
import Profile from './components/layout/Profile.js';
import AssetManagement from './components/AssetManagement/AssetManagement.js';
import ComingSoonDashboard from './components/Dashboard/ComingSoonDashboard.js';
import OnBoardConfig from './components/settings/OnBoardConfig.js';
import Billing from './components/Sales/Billing.js';

function App() {
  const navigate = useNavigate();
  const [blockedDocument, setBlockedDocument] = useState(false);
const lss = new LocalStorageService();
GV.userDet = lss.getItem('userDet')

useEffect(() => {
  if(blockedDocument) {
      setTimeout(() => {
          setBlockedDocument(false);
      }, 3000);
  }
  if(GV.userDet === undefined){
    navigate('/')
   }
}, [blockedDocument])

const blockDocument = () => {
  setBlockedDocument(true);
}

  return (
    <div className="App">
<Suspense
        fallback={
          <div className="mt-5 text-center">
            {/* <img src={ImSpinner10} alt="loading" width="200" height="150" /> */}
            <ImSpinner10 color="#000" size={100} />
            {/* <ProgressSpinner/> */}
          </div>
        }
      >
    <BlockUI blocked={blockedDocument} fullScreen />
        {/* <Button type="button" label="Block" onClick={blockDocument} /> */}
      <PermissionProvider>
        <Routes>
           <Route exact path="/" element={<LoginForm />} />
           {/* <Route exact path="/coa" element={<Layout><ChartOfAccount /></Layout>} /> */}
           <Route path="/organization-profile" element={<PrivateRouter element={<Layout><OrganizationProfile /></Layout>} />} />
           <Route path="/config" element={<PrivateRouter element={<Layout><OnBoardConfig /></Layout>} />} />
           <Route path="/profile" element={<Layout><Profile /></Layout>} />
           <Route path="/customers" element={<PrivateRouter element={<Layout><Customers /></Layout>} />} />
           <Route path="/items" element={<PrivateRouter element={<Layout><ListofItems /></Layout>} />} />
           <Route path="/coa" element={<PrivateRouter element={<Layout><COATable /></Layout>} />} />
           <Route path="/journal" element={<PrivateRouter element={<Layout><JournalList /></Layout>} />} />
           <Route path="/new-journal" element={<Layout><NewJournal /></Layout>} />
           <Route path="/update-journal" element={<PrivateRouter element={<Layout><UpdateJournal /></Layout>} />} />
           <Route path="/ledger" element={<PrivateRouter element={<Layout><Ledger /></Layout>} />} />
           <Route path="/pages/vendors" element={<PrivateRouter element={<Layout><Vendor /></Layout>} />} />
           <Route path="/pages/estimate" element={<PrivateRouter element={<Layout><EstimateGrid /></Layout>} />} />
           <Route path="/general-ledger" element={<PrivateRouter element={<Layout><GeneralLedger /></Layout>} />} />
           <Route path="/pages/budget-dashboard" element={<PrivateRouter element={<Layout><NewDashboard /></Layout>} />} />
           <Route path="/detail-ledger" element={<PrivateRouter element={<Layout><LedgerSearch /></Layout>} />} />
           <Route path="/administration/security" element={<PrivateRouter element={<Layout><UserAccountManagement /></Layout>} />} />
           <Route path="/pettycash" element={<PrivateRouter element={<Layout><PettyCash /></Layout>} />} />
           <Route path="/pettycash-month" element={<PrivateRouter element={<Layout><PettyCashMonth /></Layout>} />} />
           <Route path="/budget-forecasting" element={<PrivateRouter element={<Layout><BudgetForecasting /></Layout>} />} />
           <Route path="/expenses" element={<PrivateRouter element={<Layout><Expenses /></Layout>} />} />
           <Route path="/fund-request" element={<PrivateRouter element={<Layout><FundRequest /></Layout>} />} />
           <Route path="/fund-approval" element={<PrivateRouter element={<Layout><FundApproval /></Layout>} />} />
           <Route path="/expense-analysis" element={<PrivateRouter element={<Layout><ExpenseAnalysis /></Layout>} />} />
           <Route path="/expenses-analysis" element={<PrivateRouter element={<Layout><ExpenseSummary /></Layout>} />} />
           <Route path="/expense-summaryview" element={<PrivateRouter element={<Layout><ExpenseSummaryView /></Layout>} />} />
           <Route path="/pettycash-report" element={<Layout><PettyCashReport /></Layout>} />
           <Route path="/pettycash-weekview"  element={<Layout><PettyCashWeek /></Layout>} />
           <Route path="/purchase-expense" element={<PrivateRouter element={<Layout><PurchaseExpense /></Layout>} />} />
           <Route path="/new-purchase" element={<PrivateRouter element={<Layout><NewPurchase /></Layout>} />} />
           <Route path="/expense-tracking" element={<PrivateRouter element={<Layout><ExpenseTracking /></Layout>} />} />
           <Route path="/purchase-list" element={<PrivateRouter element={<Layout><PurchaseList /></Layout>} />} />
           <Route path="/invoice" element={<PrivateRouter element={<Layout><Invoice /></Layout>} />} />
           <Route path="/pages/creditnote" element={<PrivateRouter element={<Layout><CreditNoteGrid /></Layout>} />} />
           <Route path="/purchase/newpurchaseorder" element={<PrivateRouter element={<Layout><NewPurchaseOrderGrid /></Layout>} />} />
           <Route path="/purchase/debitnote" element={<PrivateRouter element={<Layout><DebitNoteGrid /></Layout>} />} />
           <Route path="/loan" element={<PrivateRouter element={<Layout><EmployeeLoanGrid /></Layout>} />} />
           <Route path="/reportcenter" element={<Layout><ReportsCenter /></Layout>} />
           <Route path="/pages/dashboard" element={<PrivateRouter element={<Layout><Overalldashboard /></Layout>} />} />
           {/* <Route path="/pages/dashboard" element={<PrivateRouter element={<Layout><ComingSoonDashboard /></Layout>} />} /> */}
           <Route path="/dynamicform" element={<PrivateRouter element={<Layout><DynamicForm /></Layout>} />} />
           <Route path="/tds" element={<PrivateRouter element={<Layout><Tds /></Layout>} />} />
           <Route path="/banking" element={<PrivateRouter element={<Layout><BankTransaction /></Layout>} />} />
           <Route path="/access-denied" element={<Layout><AccessDenied /></Layout>} />
           <Route path="/ticket" element={<Layout><Ticket /></Layout>} />
           <Route path="/sales/receiptvoucher" element={<Layout><PaymentVoucher /></Layout>} />
           <Route path="/sales/billing" element={<Layout><Billing /></Layout>} />
           <Route path="/purchase/paymentvoucher" element={<Layout><ReceiptVoucher /></Layout>} />
           <Route path="/banking-details" element={<Layout><Banking /></Layout>} />
           <Route path="/asset-management" element={<Layout><AssetManagement /></Layout>} />
        </Routes>
      </PermissionProvider>
</Suspense>
    </div>
  );
}

export default App;
